/* eslint-disable no-unused-vars */

export enum INTERACTION_PARAMS {
  IS_SIGNAL = 'is_signal',
  IS_PORTFOLIO = 'is_portfolio',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.IS_SIGNAL]?: boolean;
  [INTERACTION_PARAMS.IS_PORTFOLIO]?: boolean;
};

export type JobParams = {
  window: number;
  unlevered?: boolean;
};
export type Params = JobParams & InteractionParams;
export type DraftParams = Partial<Params>;
